module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-12-28 at 5.48.12 PM.a68c2010.png";